// Perforated boarding-pass divider with an optional mono caption. The
// vertical variant is the tear-off line between dialog columns.
export default function JournalDivider({ label, vertical, className = '' }) {
  if (vertical) {
    return (
      <div
        aria-hidden="true"
        className={`tw-border-0 tw-border-l tw-border-dashed tw-border-[#C9C0AA] dark:tw-border-[#3A4D44] ${className}`}
      />
    );
  }
  const line =
    'tw-h-0 tw-flex-1 tw-border-0 tw-border-t tw-border-dashed tw-border-[#C9C0AA] dark:tw-border-[#3A4D44]';
  return (
    <div
      className={`tw-flex tw-items-center tw-gap-3 ${className}`}
      role="separator"
    >
      <span className={line} />
      {label && (
        <span className="tw-font-mono tw-text-[10px] tw-font-medium tw-uppercase tw-tracking-[0.22em] tw-text-[#8A958F]">
          {label}
        </span>
      )}
      <span className={line} />
    </div>
  );
}
